import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { site, publicUrl } from "../content";

const navbarVariants = {
  hidden: { y: -50, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.6, ease: "easeInOut" },
  },
};

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navLinks = site.nav;

  return (
    <>
      <motion.nav
        initial="hidden"
        animate="visible"
        variants={navbarVariants}
        // Use relative flow for standard positioning, or absolute on specific pages if desired.
        // Opted for absolute top-0 so it doesn't force a hard block, allowing full-screen images to bleed upward seamlessly.
        className="absolute top-0 left-0 w-full z-50 px-6 py-6 flex justify-between items-center"
      >
        <Link to="/" className="flex items-center z-50">
          <div className="flex items-center">
            <img
              src={publicUrl(site.brand.logo)}
              alt={site.brand.logoAlt}
              className="h-10 md:h-12 lg:h-14 object-contain filter drop-shadow-[0_2px_6px_rgba(0,0,0,0.8)]"
            />
          </div>
          <span className="type-brand uppercase ml-3 text-gray-100 lg:ml-5" style={{ textShadow: '0px 2px 6px rgba(0,0,0,0.9)' }}>
            {site.brand.name}
          </span>
        </Link>

        {/* Desktop Navigation - Flex row instead of a hidden modal */}
        <div className="hidden items-center space-x-10 md:flex">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.path}
              className={`type-nav relative py-1 text-gray-100 transition-colors duration-300 link-underline hover:text-white ${
                location.pathname === link.path ? "link-active text-white" : "hover:text-gray-300"
              }`}
              style={{ textShadow: '0px 1px 4px rgba(0,0,0,0.8)' }}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Mobile Hamburger Icon */}
        <div className="md:hidden flex items-center z-50 text-gray-100" style={{ textShadow: '0px 1px 4px rgba(0,0,0,0.8)' }}>
          <button
            onClick={toggleMenu}
            className="hover:text-rust-light transition-colors cursor-pointer"
            aria-label="Toggle Menu"
          >
            {isMenuOpen ? (
              <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </motion.nav>

      {/* Mobile Navigation Menu - Now restricted to mobile only */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, x: "100%" }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: "100%" }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            className="fixed inset-0 z-40 bg-grey-dark flex flex-col justify-center items-center space-y-8 md:hidden"
          >
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.path}
                className={`type-nav-mobile text-white relative group link-underline ${
                  location.pathname === link.path ? "link-active text-white" : "hover:text-gray-300"
                }`}
                onClick={toggleMenu}
              >
                {link.label}
              </Link>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}

export default Navbar;
